import { ArrowBack, Home, Lock, Person, QrCodeScanner, TrendingUp } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import { COLOR_BUTTON_AZUL } from '../../styles/Styles';
import Avatar from '@mui/material/Avatar';
import { useNavigate } from 'react-router-dom';


export function ButtonFlotante() {
  let history = useNavigate();

  //reseterar al inicio, sin poder volver atras
  const handleHomeReset = () => {
    history('/home', { replace: true });
  };

  return (
    <IconButton
      onClick={handleHomeReset}
      variant="circular"
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        backgroundColor: COLOR_BUTTON_AZUL,
        color: '#fff',
      }}
    >
      <QrCodeScanner fontSize='large'/>
    </IconButton>
  );
}